import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: "Shield",
      title: "SSL Encrypted",
      description: "256-bit encryption"
    },
    {
      icon: "Lock",
      title: "Secure Login",
      description: "Protected access"
    },
    {
      icon: "CheckCircle",
      title: "Verified Platform",
      description: "Trusted by artists"
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex flex-col items-center text-center p-3 bg-muted rounded-lg">
            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mb-2 [data-theme='dark'] &:bg-green-900/30">
              <Icon name={feature?.icon} size={18} className="text-green-600 [data-theme='dark'] &:text-green-400" />
            </div>
            <h4 className="text-xs font-medium text-foreground mb-1">{feature?.title}</h4>
            <p className="text-xs text-muted-foreground">{feature?.description}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 text-center">
        <p className="text-xs text-muted-foreground">
          Your data is protected with bank-level security measures
        </p>
      </div>
    </div>
  );
};

export default SecurityBadges;